import { render, staticRenderFns } from "./ProductPosition.vue?vue&type=template&id=45bd667e&"
import script from "./ProductPosition.vue?vue&type=script&lang=ts&"
export * from "./ProductPosition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports